
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/artist/[slug]/articles",
      function () {
        return require("private-next-pages/[lang]/artist/[slug]/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/artist/[slug]/articles"])
      });
    }
  